/**
 * In-overlay Faucet authentication stage for BuySaito.
 * Rendered into #buysaito-stage — does not create a SaitoOverlay.
 * Back navigation lives in `.buysaito-footer-note` (same footer slot as migration text).
 */
module.exports = function () {
  var providers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var actions = providers.map(function (provider) {
    var id = String(provider.id || '').trim();
    var name = String(provider.name || id || 'Continue');
    var icon = String(provider.icon || '');
    var iconHtml = icon ? "<i class=\"".concat(icon, "\" aria-hidden=\"true\"></i>") : '';
    var label = String(provider.label || 'Continue with ' + name);
    return "\n        <button type=\"button\" class=\"saito-button-secondary buysaito-auth-provider\" data-buysaito-auth-provider=\"".concat(id, "\">\n          ").concat(iconHtml, "\n          <span>").concat(label, "</span>\n        </button>");
  }).join('');
  var body = String(message || '').trim() || 'The SAITO Faucet exists to help new users try the advanced features of the network. Registration requires a GitHub or Twitter account that is at least six months old.';
  return "\n    <div class=\"buysaito-faucet-auth\">\n      <p class=\"buysaito-faucet-auth-message\">\n        ".concat(body, "\n      </p>\n      <div class=\"buysaito-faucet-auth-actions\">\n        ").concat(actions, "\n      </div>\n    </div>\n  ");
};